'use client'

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { useAssessmentHeaderContext } from '@/contexts/AssessmentHeaderContext'

export default function AssessmentHeader() {
  const { showBackButton, onBackClick, isPending, logoHref } = useAssessmentHeaderContext()
  
  return (
    <header className="w-full py-3 sm:py-4 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center relative">
          {/* Back button - absolute positioned on mobile, hidden on desktop */}
          {showBackButton && (
            <button
              type="button"
              onClick={onBackClick}
              disabled={isPending}
              className="absolute left-0 flex items-center gap-2 text-gray-600 hover:text-gray-900 disabled:opacity-50 min-h-[44px] touch-manipulation sm:hidden"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span className="text-sm font-medium">Back</span>
            </button>
          )}
          
          {/* Logo - centered */}
          <Link
            href={logoHref}
            aria-label={logoHref === 'https://www.lifehack.org' ? 'LifeHack home' : 'Report contents'}
            className="hover:opacity-80 transition-opacity"
          >
            <Image
              src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/lifehack-logo-green.svg`}
              alt="LifeHack"
              width={120}
              height={40}
              className="h-6 sm:h-8 w-auto"
            />
          </Link>
        </div>
      </div>
    </header>
  )
}
